import { EnvelopeIcon,UserIcon,CakeIcon } from "@heroicons/react/24/outline";
import { Link,useNavigate } from "react-router-dom";

import { AVATARS } from "../../services/lib/assetsAvatars.js";
import { BASE_GAP_CLASS } from "../../services/lib/constants.js";
import { formatDate } from "../../services/utils/helpers.js";
import { useDispatch,useSelector } from "react-redux";
import IconWrapper from "../../component/ui/IconWrapper.js";
import Heading from "../../component/ui/Heading.js";
import Button from "../../component/ui/Button.js";
import Separator from "../../component/ui/Separator.js";
import selectedAvatarWebp from '../../services/lib/noavatars/noAvatarM.webp';
import selectedAvatarPng from '../../services/lib/noavatars/noAvatarM.png';
import { urlServerCollaudoMyjob,urlServerMyjob} from "../../constants/endpoints";
import VideoRow from "../../component/VideoRow/VideoRow.js";
import { clearAuth } from "../../store/authSlice.js";

function ProfileDetails() {
  const dispatch = useDispatch();
 const navigate=useNavigate();
  const { name,avatar,utente } = useSelector(state => state.user);

  // Costruisce l'URL avatar da token se disponibile
  const tokenFromUser = utente?.tokenAvatar?.pin || utente?.tokenAvatar || utente?.avatarToken || null;
  const remoteAvatarUrl = tokenFromUser ? `${urlServerMyjob}/api/Utils/DownloadFile?token=${encodeURIComponent(tokenFromUser)}` : null;

  console.log("remoteAvatarUrl",remoteAvatarUrl)
  const avatarName = avatar || "barney";
  const handleSignOut = () => {
    dispatch(clearAuth());
    localStorage.removeItem("authToken");
    localStorage.removeItem("user");
    navigate("/");
  };
  return (
    <section>
      <Heading>Profile</Heading>
      <div className="flex flex-col items-start xs:items-end xs:grid grid-cols-[auto_1fr] gap-3 xs:gap-x-6">
        <div className="sm:row-span-2">
          <div className="relative text-stone-50 text-3xl md:text-4xl group">
            {remoteAvatarUrl ? (
              <img
                src={remoteAvatarUrl}
                onError={(e) => {
                  e.currentTarget.onerror = null; 
                  e.currentTarget.src = selectedAvatarPng;
                }}
                className="rounded-lg w-[12rem] sm:w-[19rem] md:w-[21rem] lg:w-[25rem]"
                alt="User avatar"
              />
            ) : (
              <picture className="z-0">
                <source srcSet={selectedAvatarWebp} type="image/webp" />
                <img
                  src={selectedAvatarPng}
                  className="rounded-lg w-[12rem] sm:w-[19rem] md:w-[21rem] lg:w-[25rem]"
                  alt="User avatar"
                />
              </picture>
            )}
          </div>

        </div>

        <div className="flex flex-col gap-2 items-start">
          <h2 className="m-0 text-[2.5rem] sm:text-5xl md:text-6xl max-sm:-mb-1">
            {name}
          </h2>
          <div className="text-[1.8rem] md:text-[2rem] italic text-stone-400">
            {utente?.title}
          </div>
          <div className="mt-1 text-[1.4rem] md:text-2xl">
            <IconWrapper icon={<EnvelopeIcon />}>{'' + utente?.email}</IconWrapper>
          </div>
          <div className="flex gap-8 text-[1.4rem] md:text-2xl">
            <IconWrapper icon={<UserIcon />}>{'' + utente?.network?.name}</IconWrapper>
            <IconWrapper icon={<CakeIcon />}> {'' + utente?.uoa?.name}</IconWrapper>
          </div>
        </div>

        <div className="flex flex-col gap-2 items-start max-sm:col-span-2">
          <div className="text-2xl text-stone-400 italic mt-2 md:mt-4">
          </div>
          <div className={`flex ${BASE_GAP_CLASS}`}>
            <Button onClick={handleSignOut}>
              <span>Esci</span>
            </Button>
            {utente?.role === 'Admin' && (
              <Link to="/admin/utenti">
                <Button>
                  <span>Admin</span>
                </Button>
              </Link>
            )}
          </div>
        </div>
      </div>
      <Separator></Separator>
      <VideoRow title="Continua a Guardare" api="/views/unfinished" />
      <VideoRow title="Preferiti" api="/favorites/getall" />
      <VideoRow title="Consigliati" api="/user/recommended" />
    </section>
  );
}

export default ProfileDetails;
